import React from 'react';
import { useParams } from 'react-router-dom';
import { AttachmentManager } from '.';
import { DesktopContainer } from '../layouts';

export default function Attachments(_props) {
   const { context, key } = useParams();

   return (
      <DesktopContainer>
         <br /><br /><br /> 
         <AttachmentManager
            contextName={key}
            attachmentTypeId={context}
            attachmentKey={key}
            fullScreen={true}
         />
      </DesktopContainer>
   )
}
